<template>
    <div class="content-wrapper">
        <section class="content-header">
            <h1>
                Klook
                <small>List of Klook explore</small>
            </h1>
            <ol class="breadcrumb">
                <li>
                    <router-link :to="{ name: 'dashboard' }">
                        <i class="fa fa-dashboard"></i> Home
                    </router-link>
                </li>
                <li>
                <span>Klook</span>
                </li>
            </ol>
        </section>

        <section class="content">
          <div class="box">

              <div class="box-header with-border" style="overflow: unset;">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label for="name">
                        Country
                      </label>
                      <v-select
                        name="country"
                        placeholder="Select country"
                        @input="payloadCountry"
                        v-model="form.country"
                        @change="form.city = null"
                        :options="list.countries">
                      </v-select>
                    </div>
                  </div>
                  <div class="col-sm-12" v-show="params.country_id">
                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label for="name">
                            Explore ID
                          </label>

                          <input type="number"
                            class="form-control"
                            id="name"
                            v-model="params.activity_id"
                            @change="changeActivityID()"
                            placeholder="Search by Explore ID" >
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label for="status">
                            Title
                          </label>
                          <input type="text"
                            class="form-control"
                            id="title"
                            v-model="params.name"
                            v-on:keyup="fetchActivity()"
                            placeholder="Search by title" >
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label for="destination">
                            City
                          </label>
                          <v-select
                            name="city"
                            placeholder="Select city"
                            @input="payloadCity"
                            v-model="form.city"
                            :options="list.cities">
                          </v-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

          </div>

          <div class="box box-success">
            <div class="box-body no-padding">
              <div class="table-responsive">
                <table id="table" class="table table-bordered table-striped">
                  <thead>
                    <tr class="nowrap">
                      <th class="text-center" style="min-width: 5rem">Explore ID</th>
                      <th class="text-center" style="min-width: 15rem">Title</th>
                      <th class="text-center" style="min-width: 12rem">City</th>
                      <th class="text-center" style="min-width: 10rem">Country</th>
                      <th class="text-center" style="min-width: 8rem">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="isLoading && (activities.length < 1)" key="loading">
                      <td colspan="4" class="text-center">
                        <circle2></circle2>
                      </td>
                    </tr>

                    <tr v-else-if="!isLoading && (activities.length < 1)" key="empty">
                      <td class="text-center" colspan="4">Data Not Found</td>
                    </tr>

                    <tr v-else v-for="(activity, index) in activities" :key="index">
                      <td>
                        <span class="truncate">
                          {{ activity.id }}
                        </span>
                      </td>
                      <td>
                        <span class="truncate">
                          {{ activity.title }}
                        </span>
                      </td>
                      <td>
                        <span class="truncate">
                          {{ activity.city_name }}
                        </span>
                      </td>
                      <td>
                        <span class="truncate">
                          {{ activity.country_name }}
                        </span>
                      </td>
                      <td>
                        <a class="btn btn-block btn-info btn-xs"
                          @click.prevent="view(activity.id)">
                          View
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>
        <div class="box-footer">

                <Pagination
                  :pagination="pagination"
                  @goto-page="changePage" />
        </div>
          </div>
        </section>
    </div>
</template>

<script>
  /* eslint-disable max-len */
  import { sortBy } from 'lodash';
  import { Circle2 } from 'vue-loading-spinner';
  import Common from '@/mixins/Common';
  import Pagination from '@/components/modules/common/Pagination';

  export default {
    name: 'KlookIndex',
    mixins: [Common],

    data() {
      return {
        pagination: {},
        isLoading: false,
        activities: [],
        params: {
          page: 1,
          page_size: 25,
          country_id: 0,
          city_id: 0,
          activity_id: '',
          name: '',
        },
        form: {
            country: null,
            city: null,
        },

        list: {
            countries: [],
            cities: [],
        },
      };
    },

    components: {
      Circle2,
      Common,
      Pagination,
    },

    methods: {
      fetchCountries() {
        return this.axios.get('/klook/countries')
          .then((response) => {
            const countries = response.data.countries;
            this.list.countries = countries.map(item => ({ label: item.name, value: item.country_id }));
            this.isLoading = false;
          })
          .catch((error) => {
            console.log('Fetch countries error', error);
          });
      },

      fetchCities() {
        return this.axios.get(`/klook/country/${this.params.country_id}/cities`)
          .then((response) => {
            const cities = response.data.cities;
            this.list.cities = cities.map(item => ({ label: item.city_name, value: item.city_id }));
            this.isLoading = false;
          })
          .catch((error) => {
            console.log('Fetch cities error', error);
          });
      },

      setCountry() {
        return new Promise((resolve) => {
          let country = null;

          if (this.$route.query.country) {
            const countryId = parseInt(this.$route.query.country, 10);
            const sortedCountries = sortBy(this.list.countries, [o => o.name]);
            country = sortedCountries.find(item => item.value === countryId);
            this.params.country_id = countryId;
          }

          this.form.country = country;
          resolve(country);
        });
      },

      setCity() {
        return new Promise((resolve) => {
          let city = null;

          if (this.$route.query.city) {
            const cityId = parseInt(this.$route.query.city, 10);
            const sortedCities = sortBy(this.list.cities, [o => o.name]);
            city = sortedCities.find(item => item.value === cityId);
            this.params.city_id = cityId;
          }

          this.form.city = city;
          resolve(city);
        });
      },

      setName() {
        return new Promise((resolve) => {
          if (this.$route.query.name) {
            this.params.name = this.$route.query.name;
          }
          resolve();
        });
      },

      payloadCountry(payload) {
        if (payload) {
          this.params.country_id = payload.value;
        } else {
          this.resetParams();
        }
        this.fetchCities();
        this.setCity();
        this.pushState();
        this.fetchActivity();
      },

      payloadCity(payload) {
        if (payload) {
          this.params.city_id = payload.value;
        } else {
          this.params.city_id = 0;
          this.form.city = null;
        }
        this.pushState();
        this.fetchActivity();
      },

      pushState() {
        const page = this.params.page;
        const country = this.params.country_id;
        const city = this.params.city_id;
        const activity = this.params.activity_id;
        const name = this.params.name;
        window.history.pushState(`Klook page: ${page}`, null, `/klook?country=${country}&city=${city}&activity=${activity}&name=${name}&page=${page}`);
      },

      resetParams() {
        this.params.country_id = 0;
        this.params.city_id = 0;
        this.params.name = '';
        this.form.city = null;
        this.activities = [];
        this.list.cities = [];
        window.history.pushState('Klook index', null, '/klook');
      },

      fetchActivity() {
        return new Promise((resolve) => {
        if (this.params.country_id) {
          this.activities = [];
          this.isLoading = true;

          this.axios.get('/klook/activities', { params: this.params })
            .then((response) => {
              const { activities } = response.data;
              this.activities = activities || [];
              this.isLoading = false;

              const totalPage = Math.ceil(response.data.total / response.data.page_size);

              this.pagination = {
                current_page: response.data.page,
                total_pages: totalPage,
              };
              this.pushState();
              resolve();
            })
            .catch((error) => {
              console.log('Fetch Activities error', error);
            });
        }
        });
      },

      changePage(pages) {
        this.params.page = pages.toString();
        this.pushState();
        this.fetchActivity();
      },

      async changeActivityID() {
        await this.fetchActivity();
        if ((this.activities.length === 1) && (this.params.activity_id)) {
          this.view(this.params.activity_id);
        }
      },

      view(id) {
        this.$router.push({
          name: 'klook-view',
          params: { id },
        });
      },

      async init() {
        this.setName();
        await this.fetchCountries();
        this.setCountry();
        await this.fetchCities();
        this.setCity();
        await this.fetchActivity();
      },
    },


    created() {
      this.init();
    },

  };
</script>

<style lang="scss" scoped>
  .pointer {
    cursor: pointer;
    background-color: #223f77;
  }

  .spinner {
    display: inline-block;
    margin: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/modules/klook/Index.vue